export default __webpack_public_path__ + "static/media/le_neubourg2.4a987763.jpg";